import React, { useState, useEffect, useRef } from 'react';
import * as api from '../services/api';
import './BookingComments.css';

function BookingComments({ bookingId, onClose }) {
  const [comments, setComments] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const endRef = useRef(null);

  useEffect(() => {
    api.getBookingComments(bookingId)
      .then(setComments)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [bookingId]);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [comments]);

  const handleSend = async () => {
    if (!newMessage.trim() || sending) return;
    setSending(true);
    try {
      const comment = await api.addBookingComment(bookingId, newMessage.trim());
      setComments(prev => [...prev, comment]);
      setNewMessage('');
    } catch (err) {
      alert('Kunne ikke sende kommentar: ' + err.message);
    } finally {
      setSending(false);
    }
  };

  const formatTime = (iso) => {
    const d = new Date(iso);
    return `${d.getDate()}/${d.getMonth() + 1} kl. ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
  };

  return (
    <div className="comments-overlay" onClick={onClose}>
      <div className="comments-panel" onClick={(e) => e.stopPropagation()}>
        <div className="comments-header">
          <h3>Kommentarer</h3>
          <button className="comments-close" onClick={onClose}>&#10005;</button>
        </div>
        <div className="comments-list">
          {loading ? (
            <p className="comments-loading">Indlæser...</p>
          ) : comments.length === 0 ? (
            <p className="comments-empty">Ingen kommentarer endnu. Skriv en besked til Ole Larsen Transport.</p>
          ) : (
            comments.map(c => (
              <div key={c.id} className={`comment-bubble comment-${c.author_type}`}>
                <div className="comment-meta">
                  <span className="comment-author">{c.author}</span>
                  <span className="comment-time">{formatTime(c.created_at)}</span>
                </div>
                <div className="comment-text">{c.message}</div>
              </div>
            ))
          )}
          <div ref={endRef} />
        </div>
        <div className="comments-input-row">
          <input
            type="text"
            className="comments-input"
            placeholder="Skriv en kommentar..."
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSend()}
            disabled={sending}
          />
          <button className="comments-send" onClick={handleSend} disabled={sending || !newMessage.trim()}>
            Send
          </button>
        </div>
      </div>
    </div>
  );
}

export default BookingComments;
